import { gql, useQuery } from '@apollo/client';

const GET_APPLICANT_DOCUMENT_PREVIEW = gql`
  query getApplicantDocumentPreview($documentId: ObjectId!, $filetype: String!) {
    getApplicantDocumentPreview(documentId: $documentId, filetype: $filetype) {
      base64
      filetype
    }
  }
`;

export const useGetApplicantDocumentPreview = (filetype: string, documentId?: string) => {
  const { data, loading } = useQuery(GET_APPLICANT_DOCUMENT_PREVIEW, {
    variables: {
      documentId,
      filetype,
    },
    skip: !documentId,
  });

  return {
    document: data?.getApplicantDocumentPreview || {},
    loading,
  };
};
